import { IValueRange } from "./IValueRange";

export class ValueRange<T = number> implements IValueRange<T> {
  constructor(
    public min: T,
    public max: T,
  ) {
  }

  clone(): ValueRange<T> {
    return new ValueRange(this.min, this.max);
  }

  static from<T>(source: IValueRange<T>): ValueRange<T> {
    return new ValueRange(source.min, source.max);
  }

  static to<T>(source: ValueRange<T>): IValueRange<T> {
    return {
      min: source.min,
      max: source.max,
    };
  }
}
